import React, { memo } from 'react';
import { Question } from '../../interfaces/question.interface';
import Box from '@mui/material/Box';
import QuestionOnQuestionnaire from './QuestionOnQuestionnaire/QuestionOnQuestionnaire';
import { QuestionStatusById } from '../../app/store/questionnaireAnswerSlice';
import '../../App.css';

interface QuestionOnQuestionnaireListProps {
  questions: Question[];
  relavantQuestionStatus?: QuestionStatusById;
  incompleteQuestionIds?:  { [key: number]: number }
}
// Custom comparison function to determine if rerender is necessary
function areEqual(
  prevProps: { questions: Question[]; incompleteQuestionIds?: { [key: number]: number } },
  nextProps: { questions: Question[]; incompleteQuestionIds?: { [key: number]: number } },
) {
  return (
    prevProps.questions === nextProps.questions &&
    prevProps.incompleteQuestionIds === nextProps.incompleteQuestionIds
  );
}

const QuestionOnQuestionnaireList = memo(({ questions, relavantQuestionStatus, incompleteQuestionIds }: QuestionOnQuestionnaireListProps) => {
  return (
        <Box mt={1}>
          {questions.map((question:Question) => (
            <QuestionOnQuestionnaire
              relavantQuestionStatus={relavantQuestionStatus ? relavantQuestionStatus[question.id] : undefined}
              key={question.id + question.slug}
              question={question}
              incompleteQuestionIds={incompleteQuestionIds}
            />
          ))}
        </Box>
  );
}, areEqual);
 
export default QuestionOnQuestionnaireList;